import styled from 'styled-components';

import { ShowAloneSide } from '../../../../../containers/Editor/constants';

interface WrapperProps {
	side: ShowAloneSide;
}

const Wrapper = styled('div')`
	position: relative;
	flex: 1 0 50%;
	padding-top: 75%;

	img {
		position: absolute;
		top: 0;
		bottom: 0;
		max-width: 100%;
		max-height: 100%;
		width: auto;
		height: auto;
		margin: auto;
		border-radius: 4px;

		${({ side }: WrapperProps) => {
			switch (side) {
				case ShowAloneSide.LEFT:
					return `
						left: auto;
						right: 0;
						border-radius: 4px 0 0 4px;
					`;
				case ShowAloneSide.RIGHT:
					return `
						right: auto;
						left: 0;
						border-radius: 0 4px 4px 0;
					`;
				case ShowAloneSide.CENTER:
				default:
					return `
						left: 0;
						right: 0;
					`;
			}
		}};
	}
`;

const EmptyWrapper = styled('div')`
	position: relative;
	flex: 1 0 50%;
	padding-top: 75%;
	top: 0;
	bottom: 0;
	max-width: 53%;
	max-height: 100%;
	width: auto;
	height: auto;
	margin: auto;
	border-radius: 4px;
	left: 0;
	right: 0;
	background-color: white;
`;

export {
	Wrapper,
	EmptyWrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Item/Image/styles.ts